import { theme } from '@ovotech/element-v5';
import styled from 'styled-components';

export const ContentContainer = styled.div`
  padding-left: ${theme.space['400']};
  padding-right: ${theme.space['400']};
  max-width: none;
  margin-left: auto;
  margin-right: auto;

  display: flex;
  flex-direction: column;
  gap: ${theme.space['800']};

  ${({ theme }) => theme.mediaQueries.mediumAndUp} {
    width: 100%;
    max-width: 66.6%;
    padding-left: ${theme.space['0']};
    padding-right: ${theme.space['0']};
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  width: 100%;
  gap: ${theme.space['400']};

  ${({ theme }) => theme.mediaQueries.smallAndUp} {
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    padding-top: ${theme.space['800']};
  }
`;
